/* eslint-disable import/prefer-default-export */

const capitalize = (str) => (
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`
);

export {
  capitalize,
}
/* eslint-enable import/prefer-default-export */
